import { render, staticRenderFns } from "./BSelect.vue?vue&type=template&id=0111e3eb"
import script from "./BSelect.vue?vue&type=script&setup=true&lang=ts"
export * from "./BSelect.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BSelect.vue?vue&type=style&index=0&id=0111e3eb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports